/**
 * Vue I18n / intlify treats @ as a linked message marker.
 * Escape literal @ in body copy (for example email addresses) before messages compile.
 */
export function escapeVueI18nPlainAtSignInString(str: string): string {
  return str.replace(/@(?![\:\.])/g, (match, offset, full) => {
    const prev = full[offset - 1];
    const next = full[offset + 1];
    if (prev === "'" && next === "'") return match;
    return "{'@'}";
  });
}

export function deepEscapeVueI18nAtInMessages<T>(input: T): T {
  if (typeof input === 'string') {
    return escapeVueI18nPlainAtSignInString(input) as T;
  }
  if (input === null || typeof input !== 'object') {
    return input;
  }
  if (Array.isArray(input)) {
    return input.map((item) => deepEscapeVueI18nAtInMessages(item)) as T;
  }
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input as Record<string, unknown>)) {
    out[key] = deepEscapeVueI18nAtInMessages(value);
  }
  return out as T;
}
